var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function AlignLeft2IconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 6.00426C6 5.44962 6.44463 5 7.00087 5H20.9991C21.5519 5 22 5.45098 22 6.00426V9.99573C22 10.5504 21.5554 11 20.9991 11H7.00087C6.44811 11 6 10.549 6 9.99573V6.00426ZM8 7V9H20V7H8ZM6 14.0043C6 13.4496 6.44911 13 6.9954 13H15.0046C15.5543 13 16 13.451 16 14.0043V17.9957C16 18.5504 15.5509 19 15.0046 19H6.9954C6.44565 19 6 18.549 6 17.9957V14.0043ZM8 15V17H14V15H8ZM2 2.99865C2 2.44711 2.44386 2 3 2C3.55228 2 4 2.44577 4 2.99865V21.0014C4 21.5529 3.55614 22 3 22C2.44772 22 2 21.5542 2 21.0014V2.99865Z", fill: "" })));
}
export var AlignLeft2Icon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: AlignLeft2IconInner }, props))); };
//# sourceMappingURL=AlignLeft2Icon.js.map